import { useDragControls } from "framer-motion";
import { useEffect, useState } from "react";
import useLanguage from "../common_hooks/useLanguage";

import icon_edit_text from "../../Assets/svg/icon_edit_text.svg";
import icon_delete_2 from "../../Assets/svg/icon_delete_2.svg";
import icon_hamburger from "../../Assets/svg/icon_hamburger.svg";

import { Reorder } from "framer-motion";
import { connect, useDispatch } from "react-redux";
import { editAllFields } from "../../App/actions/layerActions";

// Komponen terpisah untuk setiap row
function DraggableRow({ f, idx, field_state, toggle_sidebar, toggle_delete_field, child, is_dragging, set_is_dragging }) {
  const dragControls = useDragControls();

  const { formula } = f;
  const rumus = formula?.map((form, i) => (
    <p
      className="inline"
      style={{ color: form.type === "operator" ? "red" : "blue" }}
      key={i}
    >
      {form.content}
    </p>
  ));

  return (
    <Reorder.Item
      as="tr"
      key={f.uuid}
      value={f}
      id={f.uuid === field_state?.uuid ? "almost_white" : ""}
      dragListener={false}
      dragControls={dragControls}
    >
      <td
        style={{
          cursor: is_dragging ? "grabbing" : "grab",
          marginRight: "10px",
        }}
        onPointerDown={(event) => {
          set_is_dragging(true);
          dragControls.start(event);
        }}
      >
        <img
          alt="draggable"
          draggable={false}
          src={icon_hamburger}
          style={{
            width: 20,
            height: 20,
          }}
        />
      </td>
      <td>{idx + 1}</td>
      <td style={{ cursor: "grab" }}>
        <div>{f.name}</div>
        {formula?.length > 0 && (
          <div style={{ border: "1px solid", padding: "5px", borderRadius: "5px", backgroundColor: "white" }}>
            {rumus}
          </div>
        )}
      </td>
      <td>
        <img
          alt="edit"
          src={icon_edit_text}
          width="13"
          className="pointer"
          onClick={() => toggle_sidebar({ ...f })}
        />
      </td>
      <td>
        <img
          alt="delete"
          src={icon_delete_2}
          width="13"
          className="pointer"
          onClick={() => toggle_delete_field({ ...f })}
        />
      </td>
      <td colSpan={2}>{child(f)}</td>
    </Reorder.Item>
  );
}

function NestedFields(props) {
  const [nested_table_fields, set_nested_table_fields] = useState([]);
  const [is_dragging, set_is_dragging] = useState(false);
  const [initial_order, set_initial_order] = useState("");

  const { field_element, field_state, child, toggle_push_field, toggle_sidebar, toggle_delete_field } = props;
  let geo_layer = props.layer.geo_layer_wo_geojson;
  geo_layer = geo_layer?.geo_layer;


  useEffect(() => {
    const fields_nested = geo_layer?.fields?.filter(
      (f) => f.parent_uuid === field_element.uuid
    ) || [];
    set_nested_table_fields(fields_nested);
    set_initial_order(fields_nested.map(f => f.uuid).join(","));
  }, [field_element.uuid, geo_layer?.fields]);

  const { dict, language } = useLanguage();
  const dispatch = useDispatch();

  const submit_reorder_nested = () => {
    const current_order = nested_table_fields.map(f => f.uuid).join(",");

    // Kalau urutan tidak berubah, skip
    if (current_order === initial_order) {
      return;
    }

    let geo_layer = props.layer.geo_layer_wo_geojson;
    geo_layer = geo_layer?.geo_layer;
    const fields_original = [...geo_layer?.fields] || [];

    // Hapus semua nested fields dari posisi lama
    let result_fields = fields_original.filter(
      (f) => f.parent_uuid !== field_element.uuid
    );

    // Cari indeks parent field
    const parent_index = result_fields.findIndex(
      (f) => f.uuid === field_element.uuid
    );

    // Insert nested fields yang sudah di-reorder setelah parent
    if (parent_index !== -1) {
      result_fields.splice(parent_index + 1, 0, ...nested_table_fields);
    } else {
      result_fields.push(...nested_table_fields);
    }

    const body = {
      geo_layer_id: geo_layer?._id,
      fields: result_fields,
    };

    dispatch(editAllFields(body));
    set_initial_order(current_order);
  };

  return (
    <table
      className="table_lite"
      onMouseUp={() => {
        if (is_dragging) {
          submit_reorder_nested();
          set_is_dragging(false);
        }
      }}
    >
      <thead>
        <tr>
          <td colSpan={4}>{dict["Sub questions"][language]}</td>
          <td>{field_element.name} 1 ({dict["Example"][language]})</td>
          <td>{field_element.name} 2 ({dict["Example"][language]})</td>
        </tr>
      </thead>

      <Reorder.Group
        as="tbody"
        axis="y"
        values={nested_table_fields}
        onReorder={set_nested_table_fields}
      >
        {nested_table_fields.map((f, idx) => (
          <DraggableRow
            key={f.uuid}
            f={f}
            idx={idx}
            field_state={field_state}
            toggle_sidebar={toggle_sidebar}
            toggle_delete_field={toggle_delete_field}
            child={child}
            is_dragging={is_dragging}
            set_is_dragging={set_is_dragging}
          />
        ))}

        {!nested_table_fields?.length ? (
          <>
            <tr>
              <td>1</td>
              <td colSpan={3}>{dict["Question 1 (Example)"][language]}</td>
              <td /><td />
            </tr>
            <tr>
              <td>2</td>
              <td colSpan={3}>{dict["Question 2 (Example)"][language]}</td>
              <td /><td />
            </tr>
          </>
        ) : null}

        <tr>
          <td colSpan={6}>
            <button
              className="button margin_auto"
              onClick={() => toggle_push_field(field_element.uuid)}
            >
              {dict["Add sub questions"][language]}
            </button>
          </td>
        </tr>
      </Reorder.Group>
    </table>
  );
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, {})(NestedFields);

// import { useDragControls } from "framer-motion";
// import { useEffect, useState } from "react";
// import useLanguage from "../common_hooks/useLanguage";

// import icon_edit_text from "../../Assets/svg/icon_edit_text.svg";
// import icon_delete_2 from "../../Assets/svg/icon_delete_2.svg";
// import icon_hamburger from "../../Assets/svg/icon_hamburger.svg";


// import { Reorder } from "framer-motion";
// import { connect, useDispatch } from "react-redux";
// import { editAllFields } from "../../App/actions/layerActions";

// function NestedFields(props) {
//   const [nested_table_fields, set_nested_table_fields] = useState([]);
//   const [is_hold, set_is_hold] = useState(false);
//   const [will_move_field_uuid, set_will_move_field_uuid] = useState("")

//   const { field_element, field_state, child, toggle_sidebar, toggle_delete_field } = props
//   let geo_layer = props.layer.geo_layer_wo_geojson;
//   geo_layer = geo_layer?.geo_layer;

//   useEffect(() => {
//     const fields_nested = geo_layer?.fields?.filter(
//       (f) => f.parent_uuid === field_element.uuid
//     );
//     set_nested_table_fields(fields_nested);
//   }, [field_element.uuid, geo_layer?.fields])

//   const dragControls = useDragControls();
//   const { dict, language } = useLanguage();
//   const dispatch = useDispatch();

//   const submit_reorder_nested = () => {
//     let geo_layer = props.layer.geo_layer_wo_geojson;
//     geo_layer = geo_layer?.geo_layer;
//     const fields_original = [...geo_layer?.fields] || [];

//     const old_fields_nested = fields_original?.filter(
//       (f) => f.parent_uuid === field_element.uuid
//     );

//     const index = nested_table_fields.findIndex(
//       (field) => field.uuid === will_move_field_uuid
//     );
//     const to_uuid = old_fields_nested[index].uuid;

//     let result_fields = [...geo_layer?.fields] || [];
//     if (fields_original.length > 0) {
//       const from = result_fields.findIndex((f) => f?.uuid === will_move_field_uuid);
//       const to = result_fields.findIndex((f) => f?.uuid === to_uuid);
//       result_fields.splice(to, 0, result_fields.splice(from, 1)[0]);

//       const old_uuid_order_str = fields_original.map(f => f.uuid).join(",")
//       const new_uuid_order_str = result_fields.map(f => f.uuid).join(",")

//       if (old_uuid_order_str !== new_uuid_order_str) {
//         const body = {
//           geo_layer_id: geo_layer?._id,
//           fields: result_fields,
//         };
//         dispatch(editAllFields(body));
//       }
//     }
//   };

//   return (
//     <table
//       className="table_lite"
//       onMouseUp={() => {
//         if (is_hold) {
//           submit_reorder_nested();
//           set_is_hold(false);
//         }
//       }}
//     >
//       {/* Header tetap di luar Reorder.Group */}
//       <thead>
//         <tr>
//           <td colSpan={4}>{dict["Sub questions"][language]}</td>
//           <td>{field_element.name} 1 ({dict["Example"][language]})</td>
//           <td>{field_element.name} 2 ({dict["Example"][language]})</td>
//         </tr>
//       </thead>

//       {/* Reorder.Group merender diri sebagai TBODY */}
//       <Reorder.Group
//         as="tbody"
//         axis="y"
//         values={nested_table_fields}
//         onReorder={set_nested_table_fields}
//       >
//         {nested_table_fields.map((f, idx) => {
//           const { formula } = f;
//           const rumus = formula.map((form, i) => (
//             <p
//               className="inline"
//               style={{ color: form.type === "operator" ? "red" : "blue" }}
//               key={i}
//             >
//               {form.content}
//             </p>
//           ));

//           return (
//             // Reorder.Item merender diri sebagai TR
//             <Reorder.Item
//               as="tr"
//               key={f.uuid || idx} // Gunakan UUID agar animasi stabil, jangan index
//               value={f}
//               id={f.uuid === field_state.uuid ? "almost_white" : ""}
//               dragListener={false}
//               dragControls={dragControls}
//             >
//               <td
//                 style={{
//                   cursor: is_hold ? "grabbing" : "grab",
//                   marginRight: "10px",
//                 }}
//                 onPointerDown={(event) => {
//                   set_will_move_field_uuid(f.uuid);
//                   set_is_hold(true);
//                   dragControls.start(event);
//                 }}
//               >
//                 <img
//                   alt="draggable"
//                   draggable={false}
//                   src={icon_hamburger}
//                   style={{
//                     width: 20,
//                     height: 20,
//                   }}
//                 />
//               </td>
//               <td>{idx + 1}</td>
//               <td
//                 style={{ cursor: "grab" }}
//               >
//                 <div>{f.name}</div>
//                 {formula?.length > 0 && (
//                   <div style={{ border: "1px solid", padding: "5px", borderRadius: "5px", backgroundColor: "white" }}>
//                     {rumus}
//                   </div>
//                 )}
//               </td>
//               <td>
//                 <img
//                   alt="edit"
//                   src={icon_edit_text}
//                   width="13"
//                   className="pointer"
//                   onClick={() => toggle_sidebar({ ...f })}
//                 />
//               </td>
//               <td>
//                 <img
//                   alt="delete"
//                   src={icon_delete_2}
//                   width="13"
//                   className="pointer"
//                   onClick={() => toggle_delete_field({ ...f })}
//                 />
//               </td>
//               <td colSpan={2}>{child(f)}</td>
//             </Reorder.Item>
//           );
//         })}

//         {/* Baris "Add Button" atau "Empty State" tetap di dalam Reorder.Group agar DOM valid */}
//         {!nested_table_fields?.length ? (
//           <>
//             <tr>
//               <td>1</td>
//               <td colSpan={3}>{dict["Question 1 (Example)"][language]}</td>
//               <td /><td />
//             </tr>
//             <tr>
//               <td>2</td>
//               <td colSpan={3}>{dict["Question 2 (Example)"][language]}</td>
//               <td /><td />
//             </tr>
//           </>
//         ) : null}

//         <tr>
//           <td colSpan={6}>
//             <button
//               className="button margin_auto"
//             // onClick={this.toggle_push_field.bind(this, field_element)}
//             >
//               {dict["Add sub questions"][language]}
//             </button>
//           </td>
//         </tr>
//       </Reorder.Group>
//     </table>
//   )
// }

// const mapStateToProps = (state) => ({
//   layer: state.layer,
//   auth: state.auth,
// });

// export default connect(mapStateToProps, {})(NestedFields);